import { render } from "./topicDialog.vue?vue&type=template&id=09291800&scoped=true"
import script from "./topicDialog.vue?vue&type=script&lang=js"
export * from "./topicDialog.vue?vue&type=script&lang=js"

import "./topicDialog.vue?vue&type=style&index=0&id=09291800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09291800"]])

export default __exports__